import React, { FC, useEffect, useState } from 'react';
import { LuArrowRight, LuMessageCircle, LuGithub, LuLinkedin, LuMail } from 'react-icons/lu';
import { FaGooglePlay } from 'react-icons/fa6';
import { profile, whatsappMessage } from '../data/profile';
import { apps } from '../data/apps';

function useTypewriter(words: string[]) {
  const [text, setText] = useState(words[0]);
  useEffect(() => {
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
    let w = 0;
    let n = words[0].length;
    let deleting = true;
    let t: ReturnType<typeof setTimeout>;
    const tick = () => {
      n += deleting ? -1 : 1;
      setText(words[w].slice(0, n));
      let delay = deleting ? 35 : 70;
      if (deleting && n === 0) {
        deleting = false;
        w = (w + 1) % words.length;
      } else if (!deleting && n === words[w].length) {
        deleting = true;
        delay = 1800;
      }
      t = setTimeout(tick, delay);
    };
    t = setTimeout(tick, 1800);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return text;
}

const Hero: FC = () => {
  const typed = useTypewriter(profile.roles);

  return (
    <section id="inicio" className="hero">
      <div className="hero__bg" aria-hidden="true" />
      <div className="container hero__inner">
        <div className="hero__text">
          <span className="badge">
            <span className="dot" /> Disponível para novos projetos
          </span>
          <h1>
            Olá, eu sou <span className="gradient">Bruno Oliveira</span>
          </h1>
          <p className="hero__role" aria-live="off">
            Desenvolvedor de <strong>{typed}</strong>
            <span className="caret" aria-hidden="true" />
          </p>
          <p className="hero__lead">
            Transformo ideias em aplicativos e sistemas que funcionam de verdade. Já publiquei mais de {apps.length} apps na Google Play
            e crio sites e plataformas web com React, Next.js e Firebase.
          </p>

          <div className="hero__cta">
            <a className="btn btn--primary" href="#apps">
              Ver meus apps <LuArrowRight size={18} />
            </a>
            <a
              className="btn btn--ghost"
              href={whatsappMessage('Olá Bruno! Vi seu portfólio e gostaria de conversar sobre um projeto.')}
              target="_blank"
              rel="noreferrer"
            >
              <LuMessageCircle size={18} /> Falar no WhatsApp
            </a>
          </div>

          <ul className="hero__social" aria-label="Redes">
            <li><a href={profile.github} target="_blank" rel="noreferrer" aria-label="GitHub"><LuGithub size={20} /></a></li>
            <li><a href={profile.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn"><LuLinkedin size={20} /></a></li>
            <li><a href={profile.playStore} target="_blank" rel="noreferrer" aria-label="Google Play"><FaGooglePlay size={17} /></a></li>
            <li><a href={`mailto:${profile.email}`} aria-label="E-mail"><LuMail size={20} /></a></li>
          </ul>
        </div>

        <div className="hero__visual">
          <div className="avatar">
            <div className="avatar__ring" aria-hidden="true" />
            <img src={`${process.env.PUBLIC_URL}/bruno.png`} alt="Avatar de Bruno Oliveira, desenvolvedor" width={320} height={320} />
          </div>
          <div className="float float--a"><strong>{apps.length}</strong><span>apps publicados</span></div>
          <div className="float float--b"><strong>Kotlin</strong><span>+ React</span></div>
        </div>
      </div>

      <div className="container">
        <dl className="stats">
          <div><dt>{apps.length}</dt><dd>Apps na Google Play</dd></div>
          <div><dt>2</dt><dd>Plataformas: Android e Web</dd></div>
          <div><dt>100%</dt><dd>Do design à publicação</dd></div>
          <div><dt>Firebase</dt><dd>Backend em nuvem</dd></div>
        </dl>
      </div>
    </section>
  );
};

export default Hero;
